import React, { memo } from 'react';
import { Collapse } from 'antd';

import { Row, Icon, Tag } from 'components/ui';

const customPanelStyle = {
  background: 'transparent',
  borderRadius: 4,
  border: 0,
  marginBottom: 5,
  overflow: 'hidden',
};

function CSVWarning({ data, label = 'Row' }) {
  if (!data) return <></>;

  return (
    <Row style={{ marginTop: 10 }}>
      <Collapse bordered={false}>
        {!!data.errors.length && (
          <Collapse.Panel
            className="collapse-error"
            header={
              <div className="flex" style={{ alignItems: 'center' }}>
                <Icon
                  style={{ color: '#E53E3E', fontSize: 16 }}
                  theme="filled"
                  type={'info-circle'}
                />
                <p
                  style={{
                    marginLeft: 5,
                    color: '#E53E3E',
                    marginBottom: -2,
                  }}
                >
                  Errors found in {data.errors.length} rows(s)
                </p>
              </div>
            }
            key="errors"
            style={customPanelStyle}
          >
            <div style={{ fontSize: 12, color: 'red', marginTop: 5 }}>
              <ul>
                {data.errors.map(({ row, message }) => {
                  return (
                    <li key={row}>
                      <b>
                        {label} {row}:
                      </b>{' '}
                      {message}
                    </li>
                  );
                })}
              </ul>
            </div>
          </Collapse.Panel>
        )}
        {!!data.variablesWarnings?.length && (
          <Collapse.Panel
            className="collapse-warning"
            header={
              <div className="flex" style={{ alignItems: 'center' }}>
                <Icon
                  style={{ color: '#D69E2E', fontSize: 16 }}
                  theme="filled"
                  type={'warning'}
                />
                <p
                  style={{
                    marginLeft: 5,
                    color: '#D69E2E',
                    marginBottom: -2,
                  }}
                >
                  Missing variables warnings found in{' '}
                  {data.variablesWarnings.length} row(s)
                </p>
              </div>
            }
            key="warning"
            style={customPanelStyle}
          >
            <div style={{ fontSize: 12, color: '#D69E2E', marginTop: 5 }}>
              <ul>
                {data.variablesWarnings.map(({ row, missingVariables }) => {
                  return (
                    <li key={row}>
                      <b>
                        {label} {row}:
                      </b>{' '}
                      Missing variables found
                      <ul>
                        {Object.entries(missingVariables).map(
                          ([templateId, variables]) => {
                            return (
                              <li key={`${row}_${templateId}`}>
                                <span className="items-center">
                                  {!!templateId &&
                                    `Template ${templateId}:{'   '}`}
                                  {variables.map(variable => (
                                    <Tag color="orange" key={variable}>
                                      {variable}
                                    </Tag>
                                  ))}
                                </span>
                              </li>
                            );
                          },
                        )}
                      </ul>
                    </li>
                  );
                })}
              </ul>
            </div>
          </Collapse.Panel>
        )}
      </Collapse>
    </Row>
  );
}

export default memo(CSVWarning);
